var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "content sis-page" },
    [
      _c(
        "div",
        { staticClass: "row-data sis-toolbar-card" },
        [
          _c("div", { staticClass: "sis-card-head" }, [
            _vm._m(0),
            _c(
              "div",
              { staticClass: "sis-card-head-actions" },
              [
                _vm.checkPermission(["tuition_excel_export_v4"])
                  ? _c(
                      "el-button",
                      {
                        attrs: {
                          type: "success",
                          size: "small",
                          icon: "el-icon-download",
                          loading: _vm.isExporting,
                          disabled: _vm.selectedStudents.length === 0,
                        },
                        on: { click: _vm.handleExportInvoices },
                      },
                      [_vm._v("Xuất Excel theo phiếu thu")]
                    )
                  : _vm._e(),
                _c(
                  "el-button",
                  {
                    staticClass: "sis-reset-btn",
                    attrs: {
                      plain: "",
                      icon: "el-icon-refresh-left",
                      size: "small",
                    },
                    on: { click: _vm.handleResetFilters },
                  },
                  [_vm._v("\n          Làm mới bộ lọc\n        ")]
                ),
              ],
              1
            ),
          ]),
          _c(
            "el-form",
            {
              ref: "searchFormRef",
              staticClass: "sis-form-grid",
              attrs: {
                model: _vm.filter,
                rules: _vm.searchRules,
                "label-position": "top",
              },
            },
            [
              _c(
                "el-form-item",
                {
                  staticClass: "sis-form-item",
                  attrs: { label: "Trạng thái học sinh" },
                },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "170px" },
                      attrs: {
                        placeholder: "Tất cả trạng thái",
                        clearable: "",
                      },
                      on: { change: _vm.handleSearch },
                      model: {
                        value: _vm.filter.kidStatus,
                        callback: function ($$v) {
                          _vm.$set(_vm.filter, "kidStatus", $$v)
                        },
                        expression: "filter.kidStatus",
                      },
                    },
                    _vm._l(_vm.statusOptions, function (s) {
                      return _c("el-option", {
                        key: s.key,
                        attrs: { label: s.label || s.value, value: s.key },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticClass: "sis-form-item",
                  attrs: { label: "Khối", prop: "idGrade" },
                },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "150px" },
                      attrs: { placeholder: "Chọn khối", clearable: false },
                      on: { change: _vm.handleGradeChange },
                      model: {
                        value: _vm.filter.idGrade,
                        callback: function ($$v) {
                          _vm.$set(_vm.filter, "idGrade", $$v)
                        },
                        expression: "filter.idGrade",
                      },
                    },
                    _vm._l(_vm.gradeOfSchoolList, function (g) {
                      return _c("el-option", {
                        key: g.id,
                        attrs: { label: g.gradeName, value: g.id },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticClass: "sis-form-item",
                  attrs: { label: "Lớp", prop: "idClass" },
                },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "180px" },
                      attrs: { placeholder: "Chọn lớp", clearable: false },
                      on: { change: _vm.handleSearch },
                      model: {
                        value: _vm.filter.idClass,
                        callback: function ($$v) {
                          _vm.$set(_vm.filter, "idClass", $$v)
                        },
                        expression: "filter.idClass",
                      },
                    },
                    _vm._l(_vm.filteredClasses, function (c) {
                      return _c("el-option", {
                        key: c.id,
                        attrs: { label: c.className, value: c.id },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticClass: "sis-form-item",
                  attrs: { label: "Tìm theo tên học sinh" },
                },
                [
                  _c("el-input", {
                    staticStyle: { width: "250px" },
                    attrs: {
                      placeholder: "Nhập tên học sinh...",
                      clearable: "",
                    },
                    on: { clear: _vm.handleSearch },
                    nativeOn: {
                      keyup: function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        )
                          return null
                        return _vm.handleSearch.apply(null, arguments)
                      },
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "append",
                        fn: function () {
                          return [
                            _c("el-button", {
                              attrs: { icon: "el-icon-search" },
                              on: { click: _vm.handleSearch },
                            }),
                          ]
                        },
                        proxy: true,
                      },
                    ]),
                    model: {
                      value: _vm.filter.studentName,
                      callback: function ($$v) {
                        _vm.$set(_vm.filter, "studentName", $$v)
                      },
                      expression: "filter.studentName",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("div", { staticClass: "row-data sis-table-card" }, [
        _c("div", { staticClass: "sis-card-head sis-table-head" }, [
          _c("div", [
            _c("p", { staticClass: "sis-card-title" }, [
              _vm._v("Danh sách học sinh"),
            ]),
            _c("p", { staticClass: "sis-card-subtitle" }, [
              _vm._v(
                "\n          Hiển thị " +
                  _vm._s(_vm.studentRows.length) +
                  " / " +
                  _vm._s(_vm.totalElements) +
                  " học sinh. Bấm vào nút tác vụ để xem chi tiết phiếu thu.\n        "
              ),
            ]),
          ]),
        ]),
        _c(
          "div",
          { staticClass: "sis-table-wrapper" },
          [
            _c(
              "el-table",
              {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.loading,
                    expression: "loading",
                  },
                ],
                ref: "studentTableRef",
                staticClass: "sk-table sis-main-table",
                attrs: {
                  data: _vm.studentRows,
                  border: "",
                  "highlight-current-row": "",
                  "empty-text": _vm.emptyText,
                  "max-height": _vm.$tableMaxHeight,
                },
                on: { "selection-change": _vm.handleSelectionChange },
              },
              [
                _c("el-table-column", {
                  attrs: { type: "selection", width: "52", fixed: "left" },
                }),
                _c("el-table-column", {
                  attrs: {
                    type: "index",
                    label: "STT",
                    width: "50",
                    align: "center",
                    fixed: "left",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "studentName",
                    label: "Họ và tên",
                    "min-width": "220",
                    fixed: "left",
                    align: "left",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function ({ row }) {
                        return [
                          _c(
                            "el-tooltip",
                            {
                              attrs: {
                                content: `Mã HS: ${row.studentCode || "—"}`,
                                placement: "top",
                                enterable: false,
                              },
                            },
                            [
                              _c(
                                "span",
                                { staticClass: "sis-student-name-cell" },
                                [_vm._v(_vm._s(row.studentName))]
                              ),
                            ]
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: {
                    label: "Phiếu lớp",
                    "min-width": "140",
                    align: "center",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function ({ row }) {
                        return [
                          _c(
                            "span",
                            {
                              staticClass:
                                "sis-count-badge sis-count-badge--class",
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    row.summary
                                      ? row.summary.classInvoiceCount || 0
                                      : 0
                                  ) +
                                  "\n            "
                              ),
                            ]
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: {
                    label: "Phiếu nhóm",
                    "min-width": "140",
                    align: "center",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function ({ row }) {
                        return [
                          _c(
                            "span",
                            {
                              staticClass:
                                "sis-count-badge sis-count-badge--group",
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    row.summary
                                      ? row.summary.groupInvoiceCount || 0
                                      : 0
                                  ) +
                                  "\n            "
                              ),
                            ]
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: {
                    label: "Phiếu gói",
                    "min-width": "140",
                    align: "center",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function ({ row }) {
                        return [
                          _c(
                            "span",
                            {
                              staticClass:
                                "sis-count-badge sis-count-badge--package",
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    row.summary
                                      ? row.summary.packageInvoiceCount || 0
                                      : 0
                                  ) +
                                  "\n            "
                              ),
                            ]
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: {
                    label: "Tổng phải thu",
                    align: "right",
                    "min-width": "140",
                    "class-name": "sis-finance-column",
                    "label-class-name": "sis-finance-header",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function ({ row }) {
                        return [
                          _c(
                            "span",
                            { staticClass: "sis-money sis-money--bold" },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm._f("formatCurrency")(
                                      row.summary ? row.summary.totalMoney : 0
                                    )
                                  ) +
                                  "\n            "
                              ),
                            ]
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: {
                    label: "Còn lại",
                    align: "right",
                    "min-width": "140",
                    "class-name": "sis-finance-column",
                    "label-class-name": "sis-finance-header",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function ({ row }) {
                        return [
                          _c(
                            "span",
                            {
                              staticClass: "sis-money",
                              class:
                                row.summary && row.summary.remainingMoney > 0
                                  ? "sis-money--positive"
                                  : "sis-money--negative",
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm._f("formatCurrency")(
                                      row.summary
                                        ? row.summary.remainingMoney
                                        : 0
                                    )
                                  ) +
                                  "\n            "
                              ),
                            ]
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: {
                    label: "Tác vụ",
                    width: "90",
                    align: "center",
                    fixed: "right",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function ({ row }) {
                        return [
                          _c(
                            "el-tooltip",
                            {
                              attrs: {
                                content: "Xem chi tiết phiếu thu",
                                placement: "top",
                                enterable: false,
                              },
                            },
                            [
                              _c("el-button", {
                                attrs: {
                                  size: "mini",
                                  type: "primary",
                                  icon: "el-icon-tickets",
                                  circle: "",
                                  plain: "",
                                },
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                    return _vm.handleOpenDetail(row)
                                  },
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      },
                    },
                  ]),
                }),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "sis-pagination" },
          [
            _c("el-pagination", {
              attrs: {
                background: "",
                "current-page": _vm.page + 1,
                "page-sizes": [10, 20, 50, 100],
                "page-size": _vm.size,
                total: _vm.totalElements,
                layout: "total, sizes, prev, pager, next, jumper",
              },
              on: {
                "size-change": _vm.handleSizeChange,
                "current-change": _vm.handlePageChange,
              },
            }),
          ],
          1
        ),
      ]),
      _c("student-invoice-detail-dialog", {
        ref: "detailDialog",
        on: { saved: _vm.loadSummary },
      }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", [
      _c("p", { staticClass: "sis-card-title" }, [
        _vm._v("Tổng hợp phiếu thu theo học sinh"),
      ]),
      _c("p", { staticClass: "sis-card-subtitle" }, [
        _vm._v(
          "\n          Tìm kiếm và theo dõi toàn bộ phiếu thu, công nợ tổng hợp của từng học sinh.\n        "
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }